"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var kxRouter = {
  path: '/kx',
  component: _layout.default,
  redirect: '/kx/config',
  name: 'KX',
  meta: {
    title: '开心社区',
    icon: 'clipboard'
  },
  children: [{
    path: 'config',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/config/index'));
      });
    },
    name: 'KxConfig',
    meta: {
      title: '全局配置',
      icon: ''
    }
  }, {
    path: 'account',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/account/index'));
      });
    },
    name: 'KxAccount',
    meta: {
      title: '用户账户',
      icon: ''
    }
  }, {
    path: 'flow',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/flow/index'));
      });
    },
    name: 'KxFlow',
    meta: {
      title: '资金流水',
      icon: ''
    }
  }, {
    path: 'bonus',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/bonus/index'));
      });
    },
    name: 'KxBonus',
    meta: {
      title: '直推奖管理',
      icon: ''
    }
  }, {
    path: 'level',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/level/index'));
      });
    },
    name: 'KxLevel',
    meta: {
      title: '等级管理',
      icon: ''
    }
  }, {
    path: 'medal',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/medal/index'));
      });
    },
    name: 'KxMedal',
    meta: {
      title: '勋章管理',
      icon: ''
    }
  }, {
    path: 'manual',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/manual/index'));
      });
    },
    name: 'KxManual',
    meta: {
      title: '手动入账',
      icon: ''
    }
  }, {
    path: 'payment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/payment/index'));
      });
    },
    name: 'KxPayment',
    meta: {
      title: '支付审核',
      icon: ''
    }
  }, {
    path: 'agent',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/agent/index'));
      });
    },
    name: 'KxAgent',
    meta: {
      title: '代理管理',
      icon: ''
    }
  }, {
    path: 'invite',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/invite/index'));
      });
    },
    name: 'KxInvite',
    meta: {
      title: '邀请码管理',
      icon: ''
    }
  }, {
    path: 'extract',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/kx/extract/index'));
      });
    },
    name: 'KxExtract',
    meta: {
      title: 'KX提现管理',
      icon: ''
    }
  }]
};
var _default = exports.default = kxRouter;